export default __webpack_public_path__ + "static/pay-it-faster-video-77dfc4b196268aef35535bc4f4dae206.png";